import { useEffect, useState, useCallback, useRef } from "react";
import { StationStatus } from "utils/constants";
import { useWebSocket,useAuth } from "utils/hooks";

export const useMarkerStatus = (
  topic,
  initialState = null,
  onStatusChanged,
) => {

  const {selected_tenant_id} = useAuth();

  const channelName = `${selected_tenant_id}-${topic}-status`;

  //let timeoutInterval;

  const [connectionStatusHistory, setConnectionStatusHistory] = useState({
    last: StationStatus.state.CONNECTING,
    current: StationStatus.state.CONNECTING,
  });

  const timeoutRef = useRef(null);
  const [status, setStatus] = useState(
    initialState || {
      code: StationStatus.state.CONNECTING,
      message: "Connecting",
    },
  );
  const [warning, setWarning] = useState({
    message: "",
    code: StationStatus.warning.NO_WARNING,
  });
  const [isConnected, subscribe, unsubscribe] = useWebSocket();

  const setMessagesReceivedTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setStatus((prev) => ({
        ...prev,
        code: StationStatus.state.DISCONNECTED,
        message: "Disconnected",
      }));
      setWarning((prev) => ({
        ...prev,
        code: StationStatus.warning.NO_WARNING,
      }));
    }, process.env.REACT_APP_WS_TIMEOUT);
  };

  useEffect(() => {
    if (isConnected === true) {
      // Subscribe to the desired WebSocket channel
      subscribe(channelName, handleReceiveCallbackMessage);
      setMessagesReceivedTimeout();
    }
    // Cleanup subscription on component unmount
    return () => {
      unsubscribe(channelName);

    };
  }, [isConnected, subscribe, unsubscribe]);

  useEffect(() => {
    if (connectionStatusHistory.last !== connectionStatusHistory.current)
      onStatusChanged && onStatusChanged(connectionStatusHistory, topic);
  }, [connectionStatusHistory]);

  useEffect(() => {
    updateConnectionStatus();
    //setMessagesReceivedTimeout();
  }, [status.code]);

  const handleReceiveCallbackMessage = useCallback((stompMessage) => {
    clearTimeout(timeoutRef.current);
    const payload = JSON.parse(stompMessage.body);

    setStatus((prev) => ({
      ...prev,
      code: payload.status.code,
      message: payload.status.message,
    }));
    if (
      payload.warning &&
      payload.warning.code 
    ) {
      setWarning((prev) => ({
        ...prev,
        code: payload.warning.code,
        message: payload.warning.message,
      }));
    }
    setMessagesReceivedTimeout();
  }, []);

  const handleReceiveCallbackError = (error) => {
    
  };

  const updateConnectionStatus = useCallback(() => {
    let currentStatusConn = StationStatus.state.CONNECTING;
   
    switch (status.code) {
      case StationStatus.state.CONNECTING:
        currentStatusConn = StationStatus.state.CONNECTING;
        break;

      case StationStatus.state.DISCONNECTED:
        currentStatusConn = StationStatus.state.DISCONNECTED;
        break;

      case StationStatus.state.SPECTRUM_CLEAN:
      case StationStatus.state.INTERFERENCE_DETECTED:
      case StationStatus.state.SPOOFING_DETECTED:
      case StationStatus.state.SPOOFING_AND_INTERFERENCE_DETECTED:
        currentStatusConn = StationStatus.state.AVAILABLE_DATA;
        break;
      case StationStatus.state.DATA_UNAVAILABLE:
        currentStatusConn = StationStatus.state.DATA_UNAVAILABLE;
      default:
        // if (warning.code !== StationStatus.warning.NO_WARNING) {
        //   currentStatusConn = StationStatus.state.DATA_UNAVAILABLE;
        // } else {
        currentStatusConn = status.code;
      // }
    }

    setConnectionStatusHistory((prevState) => ({
      ...prevState,
      last: prevState.current,
      current: currentStatusConn,
    }));
  }, [status.code, warning.code]);

  return {
    connectionStatusHistory,
    warning,
    status,
  };
};
